import restApiSonOff from "../http-common-sonoff";

export default class SonOffApi {

    openDoor() {
        return restApiSonOff({
            method: 'post',
            url: '/switch',
            data: {
                deviceid: "1000b8b8b3",
                data: {
                    switch: "on"
                }
            },
        })
    }

}




// WEBPACK FOOTER //
// ./src/services/apiSonoff.js